interface AttachmentFile {
    url: string;
    filename: string;
}

interface DeriveAttachmentDisplayParams {
    attachmentFile?: AttachmentFile;
    uploadPreviewUrl?: string;
    uploadingFileName?: string;
    fallbackUrl?: string;
}

interface AttachmentDisplay {
    imageSrc: string | undefined;
    label: string | undefined;
    showRow: boolean;
}

export function deriveAttachmentDisplay({
    attachmentFile,
    uploadPreviewUrl,
    uploadingFileName,
    fallbackUrl,
}: DeriveAttachmentDisplayParams): AttachmentDisplay {
    const imageSrc = uploadPreviewUrl ?? attachmentFile?.url ?? fallbackUrl;
    const label =
        attachmentFile?.filename ??
        uploadingFileName ??
        (fallbackUrl
            ? fallbackUrl.split('/').pop() || 'Attachment'
            : undefined);
    const showRow = !!imageSrc;

    return { imageSrc, label, showRow };
}
